import { render, staticRenderFns } from "./StatisticsContainer.vue?vue&type=template&id=2f171482&scoped=true&"
import script from "./StatisticsContainer.vue?vue&type=script&lang=js&"
export * from "./StatisticsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f171482",
  null
  
)

export default component.exports